<template lang='pug'>
#conlayout(ref="layout")
  #download
    template(v-for="item in sec")
      .downbox()
        .bar
          .sectitle(v-html="item.title")
          el-button(class ="downbut" style='width:120px; height:40px;' type="primary"  icon='el-icon-download' @click="downfile(item.url)") 下载
        .hspace
        .sec
          template(v-if="getWSStatus")
            img(
              :src="item.img",
              :style="{ width: item.imgWidth + 'px', maxWidth: '60%' }"
            )
          template(v-else)
            img(:src="item.img", style="width: 90%")
          .space
          .desc
            el-row(style="width:100%;" :getter="10")
              el-col(:span='6')
                .secDesc() 操作系统:
              el-col(:span='18')
                .secDesc(v-html="item.system")
            el-row(style="width:100%;" :getter="10")
              el-col(:span='6')
                .secDesc() 版本:
              el-col(:span='18')
                .secDesc(v-html="item.ver")
            el-row(style="width:100%;" :getter="10")
              el-col(:span='6')
                .secDesc() 发布时间:
              el-col(:span='18')
                .secDesc(v-html="item.sdate")
            el-row(style="width:100%;" :getter="10")
              el-col(:span='6')
                .secDesc() 产品简介:
            el-row(style="width:100%;" :getter="10")
              el-col(:span='24')
                .secDesc(v-html="item.desc") 

  //- el-dialog()
  //-   </div>
</template>
  
  <script>

import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "download",
  mounted() {
  },
  data() {
    return {

      lastScrollPos: 0,
      scrollUpdate: false,
      sec: [], //product.home.sec,
      bodyHeight: 0,
      bodyWidth: 0,
      textSize: 12,
    };
  },
  methods: {
    onScroll(e) {
      console.log(e);
    },
    downfile(url){
      window.open(url);
    },
    pageUpdate() {
      console.log(this.lastScrollPos);
      for (let item of this.texts)
        if (
          this.lastScrollPos > this.bodyHeight * item.min &&
          this.lastScrollPos < this.bodyHeight * item.max
        ) {
          item.vis = true;
        } else {
          item.vis = false;
        }
    },
  },
  computed: {
    ...mapGetters({
      getWSStatus: "getWSStatus",
    }),
    // player() {
    //   return this.$refs.videoPlayer.player;
    // },
    secHeight() {
      return window.screen.availHeight * 0.85;
      // return  750;
    },
  },
  mounted: function () {
    // window.addEventListener('resize',()=>{
    //     this.secheight = this.$refs.layout.clientHeight;
    // })
    // let script = document.createElement('script')
    // script.src = './data/product.json'
    // document.body.appendChild(script)
    axios({ url: "./data/download.json", method: "get" }).then((res) => {
      this.data = [];
      if (res.data) {
        this.sec = res.data.data;
      }
    });
  },
};
</script>
  <style lang="less" scoped>
#conlayout {
  width: 100%;
  height: 100%;
}
#download {
  width: 100%;
  height: 100%;
  // background-color: #252525;
  font-size: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  // img {
  //   width: 100%;
  // }

  // #info {
  //   width: calc(100% - 20px);
  //   height: 200px;
  //   background-color: #252525;
  //   padding: 10px;
  // }
}
#toolbar {
  height: 60px;
  width: calc(100% - 40px);
  background-color: #35353577;
  // position: fixed;
  // top: 120;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0 40px 10px 0;
  z-index: 999999;
  a {
    color: #dfdfdf;
    font-size: 10pt;
    margin-left: 20px;
  }
}
@media screen and (min-width: 800px) {
  .downbox{
    // border:1px solid #aaa;
    margin: 15px 0;
    height:600px;
    // background-color:#ccc;
  .sec {
    width: 100%;
    max-width: 1024px;
    // height:768px;
    // background-color: #444;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    // max-height: 950px;

    .desc {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width:30%;
    }
    // .img{
    //   width:500px;
    // }
    .secDesc {
      font-size: 10pt;
      max-width: 90%;
      line-height: 20pt;
      color:#333;
      text-align: left;
    }
  }
    .space {
      width: 5%;
    }
    .hspace {
      height: 30px;
    }
  .bar{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height:80px;
    padding: 0 10px;
    // background-color: #336699;
    border-bottom: 1px solid #aaa;
    .sectitle {
      font-size: 18pt;
      color:#333;
      margin: 20px 0;
    }
  }
  }
}
@media screen and (max-width: 800px) {
  .sec {
    width: 100%;
    // height:768px;
    // background-color: #444;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;

    .desc {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 0;
    }
    .space {
      height: 0%;
    }
    .sectitle {
      font-size: 16pt;
      // color:#fff;
      margin: 20px 0;
    }
    .secDesc {
      font-size: 10pt;
      // color:#fff;
    }
  }
}
.floatText {
  position: absolute;
  font-size: 30pt;
  color: #fff;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.fade-left-enter-active,
.fade-right-enter-active {
  transition: all 1s ease;
}
.fade-left-leave-active,
.fade-right-leave-active {
  transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-left-enter, .fade-left-leave-to 
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-50px);
  opacity: 0;
}
.fade-right-enter, .fade-right-leave-to 
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(50px);
  opacity: 0;
}
</style>
  
  